import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import "./CreateLeadModal.css";
import GetAPI from "../../APICalls/GetAPI";

const CreateLeadModal = ({ showModal, handleClose }) => {
  const [organisationName, setOrganisationName] = useState("");
  const [number, setNumber] = useState(null);
  const [corporateMenuw, setCorporateMenus] = useState(null); 
  const [mealCount, setMealCount] = useState(10);  
  const [preference, setPreference] = useState([]);
  const [cuisine, setCuisine] = useState([]);

  const getCorporateMenus = () => {
    let environment = process.env.REACT_APP_NODE_ENV;
    let menusApi;
    if (environment === "PRODUCTION" || environment === undefined) {
        menusApi = process.env.REACT_APP_PROD_CORPORATEMENU;
    } else {
        menusApi = process.env.REACT_APP_DEV_CORPORATEMENU;
    }
    let corporateMenusAPI = menusApi + "?type=ALL";
    
    GetAPI(corporateMenusAPI)
    .then((res) => {
        console.log("res ", res);
    //   if(res.data.statusCode === 200) {
    //     alert("Successfully retried daas booking!!!")
    //   } else {
    //     alert("Failed to retry daas booking!!!");
    //     console.log(res);
    //   }
    })
    .catch((e) => {
      console.error(e);
      alert("Failed to retry daas booking!!!");
    });
  }

  useEffect(() => {
    getCorporateMenus();
  },[])

  const handlePreferenceChange = (type) => {
    if (preference.includes(type)) {
      setPreference(preference.filter((item) => item !== type));
    } else {
      setPreference([...preference, type]);
    }
  };

  const handleCuisineChange = (type) => {
    if (cuisine.includes(type)) {
      setCuisine(cuisine.filter((item) => item !== type));
    } else {
      setCuisine([...cuisine, type]);
    }
  };

  const handleSliderChange = (e) => {
    setMealCount(e.target.value);
  };

  const handleSubmit = () => {
    console.log({
      organisationName,
      mealCount,
      preference,
      cuisine,
    });
    handleClose();
  };

  return (
    <Modal
      className="subscriptionModal"
      show={showModal}
      size="lg"
      scrollable={true}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Create a New Lead</Modal.Title>
        <p className="cross" onClick={handleClose}>
          &#10060;
        </p>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Organization Name */}
          <Form.Group controlId="organisationName">
            <Form.Label>Organisation Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter organisation name"
              value={organisationName}
              onChange={(e) => setOrganisationName(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="organisationName" className="my-3">
            <Form.Label>Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter contact number"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
            />
          </Form.Group>

          {/* Meal Slider */}
          <Form.Group controlId="mealSlider" className="my-3">
            <Form.Label>How many meals do you want everyday?</Form.Label>
            <div className="d-flex align-items-center">
              <span>{mealCount}</span>
              <input
                type="range"
                className="form-range"
                min="1"
                max="100"
                value={mealCount}
                onChange={handleSliderChange}
                style={{ marginLeft: "10px", flexGrow: 1 }}
              />
            </div>
          </Form.Group>

          {/* Preference Selection */}
          <Form.Group controlId="preference" className="my-3">
            <Form.Label>What's your preference?</Form.Label>
            <Row>
              <Col>
                <Button
                  variant={preference.includes("veg") ? "primary" : "outline-primary"}
                  onClick={() => handlePreferenceChange("veg")}
                  className="w-100"
                >
                  VEG
                </Button>
              </Col>
              <Col>
                <Button
                  variant={preference.includes("nonveg") ? "primary" : "outline-primary"}
                  onClick={() => handlePreferenceChange("nonveg")}
                  className="w-100"
                >
                  NON VEG
                </Button>
              </Col>
            </Row>
          </Form.Group>

          {/* Cuisine Selection */}
          <Form.Group controlId="cuisine" className="my-3">
            <Form.Label>What's your preferred cuisine?</Form.Label>
            <Row>
              <Col>
                <Button
                  variant={cuisine.includes("southIndian") ? "primary" : "outline-primary"}
                  onClick={() => handleCuisineChange("southIndian")}
                  className="w-100"
                >
                  South Indian
                </Button>
              </Col>
              <Col>
                <Button
                  variant={cuisine.includes("northIndian") ? "primary" : "outline-primary"}
                  onClick={() => handleCuisineChange("northIndian")}
                  className="w-100"
                >
                  North Indian
                </Button>
              </Col>
            </Row>
          </Form.Group>

          {/* Submit Button */}
          <Button variant="dark" onClick={handleSubmit} className="w-100">
            Get Quote
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateLeadModal;
